import axiosInstance from 'api/axiosInstance';
import colors from 'theme/themeColors.json';
import type { TagItemType } from 'types/repository.types';

const tagColors = [
  colors.bank.DEFAULT,
  colors.expenses.DEFAULT,
  colors.taxes.DEFAULT,
  colors.revenues.DEFAULT,
  '#F59E0B',
  '#EF4444',
];

const createRepositoryTag = (tagName: string): Promise<TagItemType> =>
  axiosInstance.post('/v2/repository-document-tags', {
    name: tagName,
    color: tagColors[Math.floor(Math.random() * tagColors.length)],
  });

export default createRepositoryTag;
